import { memberApiV2 } from '@lib/api';
import {
  TCreateMerchantParams,
  TMyMerchantSearchParams,
  TMyProviders,
  TSoftwareMerchants,
  TSoftwareMerchantSearchParams,
} from 'types/software-provider.types';

export function getSoftwareMerchants(providerId: string, params?: TSoftwareMerchantSearchParams) {
  return memberApiV2.request<{ data: TSoftwareMerchants }>(
    '/management/private/software-provider/merchant',
    {
      method: 'GET',
      params,
      headers: {
        'provider-id': providerId,
      },
    },
  );
}

export function getProviderMerchants(providerId: string, params?: TMyMerchantSearchParams) {
  return memberApiV2.request<{ data: TMyProviders }>(
    '/management/private/software-provider/merchant-provider-request',
    {
      method: 'GET',
      params,
      headers: {
        'provider-id': providerId,
      },
    },
  );
}

export function createProviderMerchants(providerId: string, data: TCreateMerchantParams) {
  return memberApiV2.request('/management/private/software-provider/merchant', {
    method: 'POST',
    data,
    headers: {
      'provider-id': providerId,
    },
  });
}

export function deleteProviderMerchants(providerId: string, merchantId: string) {
  return memberApiV2.request(
    `/management/private/software-provider/merchant-provider-request/${merchantId}`,
    {
      method: 'DELETE',
      headers: {
        'provider-id': providerId,
      },
    },
  );
}

export function getLegacyProviderCode(providerId: string) {
  return memberApiV2.request<{
    data: { code: string };
  }>(`/management/private/provider//software-provider/legacy/generate-code`, {
    method: 'POST',
    headers: {
      'provider-id': providerId,
    },
  });
}
